<template>
  <div class="base-basic">
    <!-- 顶部导航栏 -->
    <div class="top-nav">
      <van-icon name="arrow-left" class="back-icon" @click="goBack" />
      <div class="nav-title">意见反馈</div>
    </div>

    <!-- 主体内容 -->
    <div class="body-content">
      <div class="feedback-form">
        <div class="form-title">我的建议</div>
        <van-field
          v-model="feedbackContent"
          type="textarea"
          placeholder="您的建议请在文本框内描述............"
          rows="6"
          maxlength="500"
          show-word-limit
          :border="false"
          class="feedback-textarea"
        />
        
        <van-button
          type="primary"
          block
          class="submit-button"
          @click="submitFeedback"
        >
          提交建议
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/api/axios';
import { Button, showSuccessToast, showFailToast } from 'vant';


export default {
  name: 'FeedbackPage',
  data() {
    return {
      feedbackContent: '',
      isLoading: false
    }
  },
  methods: {
    goBack() {
      this.$router.back()
    },
    async submitFeedback() {
      // 验证输入
      if (!this.feedbackContent) {
        showFailToast('请输入反馈内容');
        return;
      }

      this.isLoading = true;
      
      try {
        // 获取用户信息
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        
        // 调用API提交反馈
        const response = await axios.post('/api/feedback', {
          user_id: userInfo.id,
          content: this.feedbackContent
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        });
        if (response.status === 200) {
          showSuccessToast('反馈提交成功');
          // 使用更明确的路由跳转代替this.$router.back()
          // 这样可以确保返回的是个人中心页面，而不是可能触发/api/meetings的会议页面
          this.$router.push('/profile');
        } else {
          showFailToast(`反馈提交失败，状态码: ${response.status}`);
        }
      } catch (error) {
        if (error.response) {
          showFailToast(`反馈提交失败: ${error.response.status} ${error.response.data?.message || ''}`);
        } else if (error.request) {
          showFailToast('网络异常，请检查网络连接');
        } else {
          showFailToast(`反馈提交失败: ${error.message}`);
        }
      } finally {
        this.isLoading = false;
      }
    }
  }
}
</script>

<style scoped>
.base-basic {
  width: 100%;
  height: 100vh;
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
}

.top-nav {
  display: flex;
  align-items: center;
  height: 48px;
  background-color: #fff;
  border-bottom: 1px solid #eee;
  padding: 0 15px;
  position: relative;
}

.back-icon {
  font-size: 20px;
  color: #333;
}

.nav-title {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

.body-content {
  flex: 1;
  padding: 20px 15px;
  overflow-y: auto;
}

.feedback-form {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
}

.form-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 15px;
}

.feedback-textarea {
  background-color: #f5f5f5;
  border-radius: 4px;
  padding: 10px;
  font-size: 14px;
  color: #333;
}

.submit-button {
  margin-top: 30px;
  background-color: #145294;
  border-radius: 4px;
  font-size: 16px;
  height: 44px;
  line-height: 44px;
}
</style>